import React, { useContext, useEffect, useMemo } from 'react'
import { Button } from 'antd'
import ContentHeader from './ContentHeader'
import { useI18n, useSurvey } from 'contexts/AuthContext'
import CareSelectButton from 'components/CareSelectButton/index'
import { ScreenKey } from './util'
import { useMetadataOptions, useStep4Location } from 'hooks/careHooks'
import { updateUserPromise } from 'apis/FitOnCareAPI'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { setBrazeProfile } from 'utils/brazeInit'
import _ from 'lodash'
import CareInput from 'components/CareInput/index'
import { isMobile } from 'utils/basic'
import { getLocalLanguage } from 'utils/authLocalStorage'
import { AuthContext } from 'contexts/AuthContext'
const Survey = (props) => {
  const { sku } = props
  const { i18n } = useI18n()
  const { survey, setSurvey } = useSurvey()
  const { helpMostOptions, diseaseHelpOptions } = useMetadataOptions()
  const { getNextScreen } = useStep4Location({ sku })
  const authContext = useContext(AuthContext)
  useEffect(() => {
    logAmplitudeEvent('Screen View: Onboarding - Condition Primary', {
      language: getLocalLanguage(),
      sku: sku,
    })
  }, [sku])

  const onSubmit = async (item) => {
    logAmplitudeEvent('Click: Onboarding - Condition Primary', {
      Condition:
        item.name === 'Other' ? `Other - ${item.otherText}` : item.name,
      language: getLocalLanguage(),
      sku: props.sku,
    })
    const hasDiseaseHelp = _.find(
      diseaseHelpOptions || [],
      (option) => option.primaryId === item.id
    )
    switch (sku) {
      case 'rd':
        updateUserPromise(
          {
            skuCondition: {
              skuPrimary: [item.id.toString()],
              skuPrimaryOther: item.otherText ? [item.otherText] : [],
              sku,
              ...(!(hasDiseaseHelp && item.available) && {
                skuSecondary: [],
                skuSecondaryOther: [],
              }),
            },
          },
          authContext
        )
        break
      default:
        break
    }
    setTimeout(() => {
      if (hasDiseaseHelp && item.available) {
        props.setCurrentKey(ScreenKey.HORMONAL_AUTOIMMUNE)
      } else {
        getNextScreen({ survey: item }).then((screenKey) => {
          props.setCurrentKey(screenKey)
        })
        setBrazeProfile({
          conditionPrimary: item.otherText
            ? `${item.name} : ${item.otherText}`
            : item.name,
        })
      }
    }, 100)
  }

  const isNextButtonEnable = useMemo(() => {
    return (
      !_.isEmpty(survey) &&
      (survey.name !== 'Other' || !_.isEmpty(survey.otherText))
    )
  }, [survey])

  return (
    <div className='info-sec'>
      <ContentHeader {...props} />
      <div className='info-content'>
        <div className='title'>
          {i18n('What can we help you with the most?')}
        </div>
        <div className='subtitle' style={{ marginBottom: '32px' }}>
          {i18n('Select one option from the list below')}
        </div>
        {helpMostOptions.map((item, index) => (
          <CareSelectButton
            key={index}
            {...{
              selected: survey.id === item.id,
              setSelected: () => {
                setSurvey({ ...item })
              },
              text: item.name,
              className: 'm-b-12 left-align',
            }}
          />
        ))}
        {survey.name === 'Other' && (
          <CareInput
            {...{
              inputValue: survey.otherText || '',
              setInputValue: (value) => {
                const regex = /^[a-zA-Z0-9\s]*$/
                if (regex.test(value)) {
                  setSurvey({
                    ...survey,
                    otherText: value,
                  })
                }
              },
              placeholder: i18n('Please specify'),
              focus: survey.name === 'Other',
              maxLength: 50,
              className: `input-sec-padding`,
            }}
          />
        )}
        <Button
          className='btn-primary full-width-btn'
          style={isMobile() ? { width: '100%' } : {}}
          onClick={() => {
            onSubmit({ ...survey })
          }}
          disabled={!isNextButtonEnable}
        >
          {i18n('Next')}
        </Button>
      </div>
    </div>
  )
}

export default Survey
